/* eslint-disable prettier/prettier */
import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Checkbox from "@material-ui/core/Checkbox";
import {
  X,
  VideoBackGround,
  Rectangle13,
  CheckboxActive,
} from "../../Constants/assets";
// Stylings

const InnerContainer = styled.div`
  width: 500px;
  height: 338px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  text-align: center;
  position: fixed;
  font-family: "Roboto", sans-serif;
  z-index: 99999; // more then the pause block element
  animation: zoomIn 0.2s ease-in-out;
  padding: 35px 30px;
  `;
const TextContainer = styled.div`
  height: max-content;
  margin-bottom: 15px;
`;
const XContainer = styled(X)``;
const Br = styled.div`
  height: 15%;
`;
const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 22%;
`;
const HeaderText = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 150%;
  color: ${(props) => props.theme.colors.black};
  height: 95%;
  text-align: center;
`;
const ParagraphText = styled.div`
  font-size: 16px;
  margin-top: 10px;
  line-height: 135%;
  color: ${(props) => props.theme.colors.black};
  display: inline-table;
`;

const ButtonContainer = styled.button`
  width: 216px;
  height: 50px;
  background: ${(props) => props.theme.colors.darkGreen};
  border-radius: 4px;
  cursor: pointer;
  border: none;
`;
const ButtonContainerLine = styled.div`
  height: 40%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;
const GetStartedButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.white};
  width: 100%;
`;
const DontShowContainer = styled.div`
  height: 13%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const DontShowText = styled.div``;
const CardCheckbox = styled(Checkbox)`
  /* && {
        position: absolute;
        right: 0;
    } */
  && {
    height: 44px;
  }
`;

// TODO: Fix this, this is temporary fix
export default function IdlePopUp({
  setIdlePopup,
  toggleIsGamePaused,
  setKeepShowing,
  keepShowing,
  isTabActive,
  setIsTabActive,
}) {
  const [beginCheckboxChecked, setbeginCheckboxChecked] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        setIsTabActive(false);
        toggleIsGamePaused(true);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [toggleIsGamePaused, setIsTabActive]);
  if (!isTabActive && keepShowing) {
    return (
      <InnerContainer>
        <TextContainer>
          <HeaderContainer>
            <HeaderText>{t('modals.timeout.info_title')}</HeaderText>
            <X
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIdlePopup(false);
                toggleIsGamePaused(false);
                setIsTabActive(true);
              }}
            />
          </HeaderContainer>
          <ParagraphText style={{ textAlign: "left" }}>
            {t('modals.timeout.info_text')}
          </ParagraphText>
        </TextContainer>
        <DontShowContainer>
          <CardCheckbox
            onChange={() => {
              setbeginCheckboxChecked(!beginCheckboxChecked);
            }}
            icon={
              <Rectangle13
                style={{
                  width: "24px",
                  height: "24px",
                  transform: "scale(0.9)",
                }}
              />
            }
            checkedIcon={
              <CheckboxActive style={{ width: "24px", height: "24px" }} />
            }
          />
          <DontShowText>{t('modals.timeout.checkbox')}</DontShowText>
        </DontShowContainer>
        <ButtonContainerLine>
          <ButtonContainer
            onClick={() => {
              setIdlePopup(false);
              toggleIsGamePaused(false);
              setIsTabActive(true);
              if (beginCheckboxChecked) {
                setKeepShowing(false);
              }
            }}
          >
            <GetStartedButton>{t('modals.timeout.button1')}</GetStartedButton>
          </ButtonContainer>
        </ButtonContainerLine>
      </InnerContainer>
    );
  }
  // if (show && secondWarning) {
  //     return (
  //         <InnerContainer>
  //             <Br />
  //             <TextContainer>
  //                 <HeaderContainer>
  //                     <HeaderText>Time Out</HeaderText>
  //                 </HeaderContainer>
  //                 <ParagraphText style={{ textAlign: 'left' }}>
  //                     {' '}
  //                     Session has been idle over its time limit. Your game is over. Please review
  //                     your game summary report and try again next time.
  //                 </ParagraphText>
  //             </TextContainer>
  //             <ButtonContainerLine>
  //                 <ButtonContainer
  //                     onClick={() => {
  //                         setIdlePopup(false);
  //                     }}
  //                 >
  //                     <GetStartedButton>Ok, Got It</GetStartedButton>
  //                 </ButtonContainer>
  //             </ButtonContainerLine>
  //         </InnerContainer>
  //     );
  // }
  return null;
}
